<template>
    <div class="page-main page-plan container">
        <lotteryHeader :lottery="lottery"></lotteryHeader>
        <div class="main-bd">
            <div class="main-bd_left">
                <div class="filter">
                    <div class="l">
                        <div class="col">
                            <div class="item">
                                <span>玩法</span>
                                <el-select v-model="wanfa_value" style="width:150px;" >
                                    <el-option
                                        v-for="item in wanfa_options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                         @click.native="clickWanfaOption(item)">
                                        </el-option>
                                </el-select>
                            </div>
                            <div class="item">
                                <span>中奖率</span>
                                <el-select v-model="condition_value" style="width:150px">
                                    <el-option
                                        v-for="item in condition_options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="col">
                            <div class="item">
                                <span>码数</span>
                                <el-input
                                    placeholder=""
                                    suffix-icon="el-icon-arrow-down"
                                    v-model="mashu_input_value"
                                    :readonly="true"
                                    @focus="clickMashu"
                                    style="width:100px" v-show="this.mashu_type == 1">
                                </el-input>
                                <el-input
                                    placeholder=""
                                    v-model="mashu_input_value"
                                    :readonly="true"
                                    style="width:100px" v-show="this.mashu_type == 2">
                                </el-input>
                                <el-select v-model="mashu_value" placeholder=""  style="width:100px"  v-show="this.mashu_type == 0">
                                    <el-option
                                        v-for="item in mashu_options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                </el-select>
                            </div>
                            <div class="item">
                                <span>期数</span>
                                <el-select v-model="group_value" placeholder=""  style="width:70px">
                                    <el-option
                                        v-for="item in group_options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                </el-select>
                            </div>
                            <div class="item">
                                <span>公式数</span>
                                <el-select v-model="gongshishu_value" placeholder=""  style="width:70px">
                                    <el-option
                                        v-for="item in gongshishu_options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="r">
                        <button class="button-1" @click="clickSearch">确定</button>
                    </div>                    
                </div>
                <div class="hd">
                    <div class="tit" @click="clickAllList()">
                        全部计划
                    </div>
                    <div class="operation">
                        <span @click="clickRankingList()" :class="list_type == 1 ? 'active' : ''"><i class="icon-ph"></i>计划排行</span>
                        <!-- <span @click="clickCollectionList()" :class="list_type == 2 ? 'active' : ''"><i class="icon-sc"></i>我的收藏</span> -->
                    </div>
                </div>
                <div class="bd">
                    <template v-if="list_type == 1">
                        <div class="line-list">
                            <div class="line-list_hd ranking-hd">
                                <div class="col-1">排名</div>
                                <div class="col-2">计划名称</div>
                                <div class="col-3">点击量</div>
                                <div class="col-4">查看</div>
                                <!-- <div class="col-5">收藏</div> -->
                                <div class="col-last"></div>
                            </div>
                            <div class="line-list_bd scrollbar ranking-bd">
                                <div class="item" v-for="(item,index) in plan_ranking_list">
                                    <div class="col-1">
                                        <span class="ball">{{ index + 1 }}</span>
                                    </div>
                                    <div class="col-2">{{item.name}}</div>
                                    <div class="col-3">{{item.click_num}}</div>
                                    <div class="col-4">
                                        <span class="b0 b1" @click="clickPlan(item,index)"><i class="el-icon-search"></i>查看</span>
                                    </div>
                                    <!-- <div class="col-5">
                                        <span class="b0 b2" @click="clickCollect(item,index)"><i class="el-icon-star-on"></i>{{item.is_collect == 1 ? '已收藏' : '收藏'}}</span>
                                    </div> -->
                                    <div class="col-last"></div>
                                </div>
                                
                            </div>
                        </div>
                    </template>
                    <template v-else-if="list_type == 2">
                        <div class="line-list">
                            <div class="line-list_hd ">
                                <div class="col-1">排名</div>
                                <div class="col-2">计划名称</div>
                                <div class="col-3">点击量</div>
                                <div class="col-4">查看</div>
                                <div class="col-5">收藏</div>
                                <div class="col-last"></div>
                            </div>
                            <div class="line-list_bd scrollbar ">
                                <div class="item" v-for="(item,index) in collect_list">
                                    <div class="col-1">
                                        <span class="ball">{{ index + 1 }}</span>
                                    </div>
                                    <div class="col-2">{{item.plan_name}}</div>
                                    <div class="col-3">{{item.click_num}}</div>
                                    <div class="col-4">
                                        <span class="b0 b1" @click="clickCollectionPlan(item,index)"><i class="el-icon-search"></i>查看</span>
                                    </div>
                                    <div class="col-5">
                                        <span class="b0 b2" @click="clickCollectClear(item,index)"><i class="el-icon-delete"></i>删除</span>
                                    </div>
                                    <div class="col-last"></div>
                                </div>
                                
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="list scrollbar" style="height:390px;">
                            <span @click="clickPlan(item,index)" class="item" :class="plan_active_index == index ? 'active' : ''" v-for="(item,index) in plan_list" v-show="index >= paging.begin_index  && index < paging.end_index ">{{item.name}}</span>
                        </div>
                        <div class="pagination">  
                            <div class="l">
                                <span>共<b>{{paging.count}}</b>页</span>
                                <span>当前第<b>{{paging.page}}</b>页</span>
                            </div>
                            <div class="r">
                                <button class="button-1" @click="clickPaging('first')">首页</button>
                                <button class="button-1" @click="clickPaging('prev')">上页</button>
                                <button class="button-1" @click="clickPaging('next')">下页</button>
                                <button class="button-1" @click="clickPaging('last')">末页</button>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="main-bd_right">
                <div class="hd">
                    <div class="l">
                    </div>
                    <div class="r">
                        <button class="button-2" @click="clickCopy('plan')">复制计划</button>
                        <button class="button-2" @click="clickCopy('number')">复制号码</button>
                        <button class="button-2" @click="clickRefresh"><i class="el-icon-refresh-left"></i>刷新</button>
                        <!-- <button class="button-2" @click="clickCollect2"><i class="el-icon-star-on"></i>收藏</button> -->
                    </div>
                </div>
                <div class="bd " style="position: relative;">
                    <div class="adv_right" v-if="adv.ad_img">
                        <a :href="adv.ad_url" target="_block">
                            <img class="adv_img" :src="adv.ad_img" alt="" srcset="">
                        </a>
                        <img class="adv_close" :src="adv.adx_img" alt="" @click="adv.ad_img = ''">
                    </div>
                    <div class="scrollbar">
                        <div v-for="(item,index) in detail_list" class="item">
                            <p v-if="item.scope">
                                <template v-if="item.more">
                                    {{item.scope}}期 
                                    【{{detail_plan_name}}】
                                    {{detail_wanfa_name}} &nbsp;
                                    【{{item.more}}注】
                                    {{item.expect}}期 &nbsp;
                                    {{item.opencode}} &nbsp;
                                    {{item.result}}
                                    <template v-if="item.wait == '进行中'">
                                        <span class="line"></span>
                                        {{item.randnum}}
                                        <span class="line"></span>
                                    </template>
                                </template>
                                <template v-else>
                                    {{item.scope}}期 
                                    【{{detail_plan_name}}】
                                    {{detail_wanfa_name}} &nbsp;
                                    【{{item.randnum}}】
                                    {{item.expect}}期 &nbsp;
                                    {{item.opencode}} &nbsp;
                                    {{item.result}}
                                </template>
                            </p>
                            <p v-else>
                                -----------------------------
                            </p>                            
                        </div>
                    </div>
                </div>
                <div class="ft">
                    <!-- '已完成'+count['zhouqi']+'个周期,正确率'+count['zql']+',错误'+count['error']+'个,最大连中'+count['z_max']+'个,最大连错'+count['g_max']+'个,当前连'+count['status']+count['r']+'个'; -->
                    正确率<span>{{total.zql}}</span>，最大连中<span>{{total.z_max}}</span>个，最大连错<span>{{total.g_max}}</span>个
                </div>
            </div>
        </div>
        <el-dialog
            title="选择玩法"
            :visible.sync="dialog_wanfa_visible"
            custom-class="dialog_wanfa"
            :before-close="dialogWanfaClose">
            <div class="wanfa_code_list">                
                <el-radio-group v-model="dialog_wanfa_code" >
                    <div v-for="(item,index) in wanfa_code_list">
                        <el-radio :label="index">{{item}}</el-radio>
                    </div>
                </el-radio-group>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogWanfaClose">取 消</el-button>
                <el-button type="primary" @click="dialogWanfaOk">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="请输入"
            :visible.sync="dialog_mashu_visible"
            custom-class="dialog_mashu"
            :before-close="dialogMashuClose">
            <div class="dialog_mashu-bd">
                码数:&nbsp;
                <el-input placeholder="开始区间" v-model="form_mashu.start" style="width: 100px;"></el-input>
                &nbsp;至&nbsp;
                <el-input placeholder="结束区间" v-model="form_mashu.end" style="width: 100px;"></el-input>
            </div>            
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialog_mashu_visible = false">取 消</el-button>
                <el-button type="primary" @click="dialogMashuOk">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';    
    import { getWanfaList } from '@/api/lottery.js';
    import { getIndex, getPlan, getPlanDetail, postPlanCollectplan, getPlanCollect,getPlanMashu2 } from '@/api/plan.js';
    import { get_random_num } from '@/utils/common.js';
    import { getAds } from '@/api/config.js';
    import lotteryHeader from '@/components/common/lotteryHeader.vue'
  
    
    export default {
        components: {
            lotteryHeader
        },
        data() {
            return {
                loty: "",
                lottery: {},//当前彩种
                plan:{},//当前计划
                plan_active_index: -1,
                plan_list: [],//全部计划
                plan_ranking_list: [],//全部计划-排行榜
                plan_ranking_active_index: -1,
                collect_list: [],//我的收藏
                paging: {
                    page: 0,
                    limit: 50,
                    count: 0,
                    total: 0,
                    begin_index: 0,
                    end_index: 50
                },
                plan_count: 0,//全部计划
                plan_page: 0,//全部计划
                detail_list:[],//计划详情列表
                list_type: 0,//0全部 1.排行  2 收藏
                dialog_wanfa_visible: false,
                wanfa: undefined,//当前选择的玩法
                wanfa_code: 0,
                dialog_wanfa_code: 0,
                wanfa_code_list: [],
                wanfa_list: [],
                wanfa_options: [],
                wanfa_value: '',
                detail_wanfa_name: '',//计划详情 显示 玩法名称
                detail_plan_name: '',//计划详情 显示 计划名称
                sound_status: true,
                condition_options: [
                    {
                        value: "",
                        label: "不限"
                    },
                    {
                        value: "100",
                        label: "100%以上"
                    },
                    {
                        value: "98",
                        label: "98%以上"
                    },
                    {
                        value: "95",
                        label: "95%以上"
                    },
                    {
                        value: "90",
                        label: "90%以上"
                    },
                    {
                        value: "80",
                        label: "80%以上"
                    },
                    {
                        value: "70",
                        label: "70%以上"
                    },
                    {
                        value: "50",
                        label: "50%以上"
                    },
                    {
                        value: "30",
                        label: "30%以上"
                    }
                ],
                condition_value: "",
                gongshishu_options: [
                    {
                        value: "20",
                        label: "20"
                    },
                    {
                        value: "50",
                        label: "50"
                    },
                    {
                        value: "80",
                        label: "80"
                    },
                    {
                        value: "100",
                        label: "100"
                    },
                    {
                        value: "150",
                        label: "150"
                    },
                    {
                        value: "200",
                        label: "200"
                    },
                    {
                        value: "300",
                        label: "300"
                    },
                    {
                        value: "400",
                        label: "400"
                    }
                ],
                gongshishu_value: 50,//公式数
                group_options: [
                    {
                        value: "1",
                        label: "1"
                    },
                    {
                        value: "2",
                        label: "2"
                    },
                    {
                        value: "3",
                        label: "3"
                    },
                    {
                        value: "4",
                        label: "4"
                    },
                    {
                        value: "5",
                        label: "5"
                    },
                    {
                        value: "6",
                        label: "6"
                    },
                    {
                        value: "7",
                        label: "7"
                    },
                    {
                        value: "8",
                        label: "8"
                    },
                    {
                        value: "9",
                        label: "9"
                    },
                    {
                        value: "10",
                        label: "10"
                    }
                ],
                group_value: 3,//期数
                mashu_options: [],
                mashu_value: '',//码数
                mashu_type: 0, //码数接口返回的type 0.列表  1.区间  2.就一个
                form_mashu: {
                    start: 0,
                    end: 0
                },
                mashu_input_value: '',//type 1 区间码数
                dialog_mashu_visible: false,
                total:{},
                copy_number:'',
                copy_plan:'',
                refresh_param: undefined,  //记录筛选条件，刷新
                issue_expect : "", //正在开奖的 期
                adv :{
                }
            };
        },
        created() {
            //奖期变化 获取最新计划
            this.$eventBus.$on('lotteryPlanIssue',(res)=>{
                //首次不触发
                if(res.countdown > 1) {
                    this.clickRefresh();
                }
            });
            getAds().then((response)=>{
                if (response.data.code == 200) {
                    let data = response.data.data;
                    if(data && data.adx_img && Number(data.is_open) === 1) {
                        this.adv = response.data.data;
                    }
                }
            });
        },
        watch:{
            $route: {
                handler: function(){
                    let loty = this.$route.params.loty;
                    if (loty && loty != 'index') {
                        this.loty = loty;
                    } else {
                        this.loty = "";
                    }
                    this.init();
                },
                immediate: true
            },
            lottery_config:{
                handler: function(val){
                    if (val && val.length > 0) {
                        this.init();
                    }
                }
            }
        },
        computed: {
            ...mapGetters(['lottery_config','lottery_all','token','expire_time'])
        },
        methods: {
            init() {
                if(this.lottery_config.length > 0 && this.lottery_config[0].list.length > 0) {
                    let lottery_data = undefined;
                    if(this.loty) {
                        lottery_data = this.lottery_all[this.loty];                        
                    }                    
                    if (lottery_data == undefined) {
                        this.lottery = this.lottery_config[0].list[0];                        
                    } else {
                        this.lottery = lottery_data;
                    }

                    this.default_loty = this.lottery_config[0].list[0];
                    if (this.default_loty.loty != this.lottery.loty) {
                        // if (this.token == undefined || this.token == "") {
                            if (0>1) {
                            this.lottery.loty = this.default_loty.loty;
                            this.$alert('用户登录查看更多计划!', '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    ;
                                }
                            });
                            this.$router.push('/plan/' + this.default_loty.loty);
                            return false;
                        } else if(this.verifyExpiretime()) {
                            this.lottery.loty = this.default_loty.loty;
                            return false;
                        }
                    }

                    this.getIndex(this.lottery.loty);
                    
                    //this.getWanfaList();
                }
            },
            verifyExpiretime() {
                if (this.token && this.expire_time) {
                    //当前时间戳
                    let now_timestamp = Date.parse(new Date()) / 1000;
                    if(now_timestamp > Number(this.expire_time)) {
                        this.$confirm('会员到期!查看更多计划需要充值会员', '提示', {
                            confirmButtonText: '充值',
                            cancelButtonText: '关闭',
                            type: 'warning'
                        }).then(() => {
                            this.$router.push('/member/recharge')
                        }).catch(() => {
                            this.$router.push('/plan/' + this.default_loty.loty);          
                        });
                        return true;
                    }                    
                }
                return false;
            },
            changeWanfa(val) {
                this.wanfa_code_list = this.wanfa_list[this.wanfa_value].list;
                this.dialog_wanfa_code = this.wanfa_code;
                this.dialog_wanfa_visible = true;
            },
            clickWanfaOption(e) {
                this.wanfa_code_list = this.wanfa_list[e.value].list;
                this.dialog_wanfa_code = this.wanfa_code;
                this.dialog_wanfa_visible = true;
            },
            dialogWanfaClose() {
                this.dialog_wanfa_visible = false;
            },
            dialogWanfaOk() {
                this.wanfa_code = this.dialog_wanfa_code;
                this.dialog_wanfa_visible = false;
                this.getPlanMashu2();
                //this.getPlanDetail();
            },
            clickMashu() {
                if (this.mashu_type == 1) {
                    this.dialog_mashu_visible = true;
                }                
            },
            dialogMashuClose() {
                this.dialog_mashu_visible = false;
            },
            dialogMashuOk() {
                let start = Number(this.form_mashu.start);
                let end = Number(this.form_mashu.end);
                if(start && end) {
                    if(this.wanfa_value == 'ex'){
                        if(!(start>0&&start<=100) || !(end>0&&end<=100)){
                            this.$message.error('请输入1-100的纯数字');
                            return false;
                        }
                    }
                    else if(this.wanfa_value == 'sanx'){
                        if(!(start>0&&start<=1000) || !(end>0&&end<=1000)){
                            this.$message.error('请输入1-1000的纯数字');
                            return false;
                        }
                    }
                    let randnum = get_random_num(start,end);
                    this.mashu_input_value = start + '至'+ end;
                    this.mashu_value = randnum;
                    this.dialog_mashu_visible = false;
                } else {
                    this.$message.error('请输入纯数字');
                }
            },
            clickPlan(item,index){
                this.plan_active_index = this.list_type == 1 ? item.index : index;
                this.plan_ranking_active_index = this.list_type == 1 ? index : -1;
                this.plan = item;
                this.getPlanDetail();
            },
            clickCollectionPlan(item){      
                let exists = false;
                for(let i=0; i < this.plan_list.length; i++) {
                    if (this.plan_list[i].id == item.collect_id) {
                        this.plan_active_index = i;
                        this.plan = this.plan_list[i];
                        exists = true;
                        break;
                    }
                }
                //收藏的计划 不在 计划列表
                if (exists === false) {
                    this.plan.id = item.collect_id;
                    this.plan.name = item.plan_name;
                    this.plan_active_index = -1;
                }
                this.getPlanDetail();
            },            
            clickSound() {
                this.sound_status = !this.sound_status;
            },
            clickAllList() {
                this.list_type = 0;
            },
            clickRankingList() {
                this.list_type = this.list_type === 1 ? 0 : 1;
                this.plan_ranking_active_index = -1;
            },
            clickCollectionList() {
                this.list_type = this.list_type === 2 ? 0 : 2;
                this.getPlanCollect();
            },
            clickRefresh() {
                this.getPlanDetail(this.refresh_param);
            },
            clickSearch() {
                this.getPlan(this.lottery.loty)
            },
            clickCollect2() {
                this.clickCollect({
                    id: this.plan.id,
                    name: this.plan.name
                }, this.plan_ranking_active_index)
            },
            clickCollect(item,index) {
                //已收藏 =取消
                let is_collect = item.is_collect == 1 ? 0 : 1;
                
                let param = {
                    wanfa: this.wanfa_value,//玩法
                    code: this.wanfa_code,
                    loty: this.lottery.loty,
                    plan_name: item.name,
                    status: is_collect,//1:收藏 0:取消收藏
                    id: item.id,
                    group: this.group_value,//期数
                    mashu: this.mashu_value,//码数
                    type: this.mashu_type
                };
                postPlanCollectplan(param).then((response)=>{
                    if (response.data.code == 200) {
                        if(index >= 0) {
                            this.plan_ranking_list[index].is_collect = is_collect;
                        }
                        if(item.index !== undefined) {
                            this.plan_list[item.index].is_collect = is_collect;
                        }
                        this.$message({
                            message: response.data.msg,
                            type: 'success'
                        });
                    }else {
                        this.$message.error(response.data.msg);
                    }
                });
            },
            clickCollectClear(item,index) {
                //收藏列表 - 取消收藏
                let param = {
                    wanfa: this.wanfa_value,//玩法
                    code: this.wanfa_code,
                    loty: this.lottery.loty,
                    plan_name: item.plan_name,
                    status: 0,//1:收藏 0:取消收藏
                    id: item.collect_id,
                    group: this.group_value,//期数
                    mashu: this.mashu_value,//码数
                    type: this.mashu_type
                };
                postPlanCollectplan(param).then((response)=>{
                    if (response.data.code == 200) {
                        this.collect_list.splice(index,1);
                        this.$message({
                            message: response.data.msg,
                            type: 'success'
                        });
                    }else {
                        this.$message.error(response.data.msg);
                    }
                });
            },
            getIndex(loty) {
                getIndex(loty).then((response)=>{
                    if (response.data.code == 200) {
                        let select = response.data.data.select;
                        let index = 0;
                        let options = [];
                        for (const key in select) {
                            if(index === 0) {
                                this.wanfa = select[key];
                                this.wanfa_value = key;
                            }
                            options.push({
                                value: key,
                                label: select[key].name
                            })
                            index++;
                        }
                        this.wanfa_list = select;
                        this.wanfa_options = options;
                        this.wanfa_code = 0;
                        this.wanfa_code_list = this.wanfa.list;

                        this.gongshishu_value = response.data.data.gongshishu;
                        this.group_value = response.data.data.group;//期数
                        this.mashu_value = response.data.data.mashu;//码数

                        this.getPlanMashu2();
                        
                    }else {
                        this.$message.error(response.data.msg);
                    }
                })

            },
            getPlan(loty) {
                let o = {
                    wanfa: this.wanfa_value,//玩法
                    condition: this.condition_value,//中奖率
                    code: this.wanfa_code,
                    group: this.group_value,//期数
                    mashu: this.mashu_value,//码数
                    nums: this.gongshishu_value,//公式数
                    gongshishu: this.gongshishu_value,
                    loty: loty,
                    type: '',                    
                    flag: 1,
                    sort: 0
                };
                //获取全部计划
                getPlan(o).then((response)=>{
                    if (response.data.code == 200) {
                        this.plan_ranking_list = [];
                        if(Array.isArray(response.data.data)) {
                            this.plan_list = response.data.data;
                            if(this.plan_list.length > 0) {
                                this.paging.page = 1;
                                //总条数
                                this.paging.total = this.plan_list.length;
                                //总页数
                                this.paging.count = Math.ceil(this.paging.total / this.paging.limit);
                                //开始下标
                                this.paging.begin_index = 0;
                                //结束下标
                                this.paging.end_index = this.paging.limit;

                                this.plan = this.plan_list[0];
                                this.plan_active_index = 0;
                                this.getPlanDetail();
                                this.plan_list.forEach((element,index) => {
                                    element.index = index;
                                    this.plan_ranking_list.push(element);
                                });
                                
                                //排行榜排序
                                function sortData(a, b) {
                                    return b.click_num - a.click_num;
                                }
                                this.plan_ranking_list.sort(sortData);
                            }
                        } else {
                            this.plan_list = [];
                            this.plan_ranking_list = [];
                            this.detail_list = [];
                            this.total = {};
                            this.paging.page = 0;
                            this.paging.total = 0;
                            this.paging.count = 0;
                        }
                    }else {
                        //this.$message.error(response.data.msg);
                    }
                })
            },
            clickPaging (type) {
                if(this.paging.count <= 1) {
                    return;
                }
                switch (type) {
                    case 'first':
                        if(this.paging.page == 1) {
                            return;
                        }
                        this.paging.begin_index = 0;
                        this.paging.end_index = this.paging.limit;
                        this.paging.page = 1;
                        return;
                    case 'last':
                        if(this.paging.page == this.paging.count || this.paging.count <= 1) {
                            return;
                        }
                        this.paging.begin_index = (this.paging.limit * this.paging.count) - this.paging.limit;
                        this.paging.end_index = this.paging.limit * this.paging.count;
                        this.paging.page = this.paging.count;
                        return;
                    case 'prev':
                        if(this.paging.page <= 1) {
                            return;
                        }
                        this.paging.begin_index = this.paging.begin_index - this.paging.limit;
                        this.paging.end_index = this.paging.end_index - this.paging.limit ;
                        --this.paging.page;
                        return;
                    case 'next':                        
                        if(this.paging.page == this.paging.count) {
                            return;
                        }
                        this.paging.begin_index = this.paging.begin_index + this.paging.limit;
                        this.paging.end_index = this.paging.end_index + this.paging.limit;
                        ++this.paging.page;
                        return;
                }
            },
            getPlanDetail(param) {
                let o = {};
                if(param)  {
                    o = param;
                } else {
                    o = {
                        id: this.plan.id,
                        plan_name: this.plan.name,
                        loty: this.lottery.loty,
                        wanfa: this.wanfa_value,//玩法
                        code: this.wanfa_code, //玩法2 下标
                        group: this.group_value,//期数
                        mashu: this.mashu_value,//码数        
                        condition: this.condition_value,//中奖率
                        type: this.mashu_type, //码数接口返回的type
                        gongshishu: this.gongshishu_value //公式数
                    };
                    this.refresh_param = o;
                }

                this.detail_plan_name = o.plan_name;
                this.detail_wanfa_name = this.wanfa_list[this.wanfa_value].name;

                //获取计划详情
                getPlanDetail(o).then((response)=>{
                    if (response.data.code == 200) {
                        let list = response.data.data.list;
                        this.detail_list = [];
                        this.total = response.data.data.count;
                        if(list.length > 0) {
                            for (let index = list.length - 1; index >= 0; index--) {
                                if(list[index].randnum && list[index].randnum.split(',').length > 10) {
                                    //注数 > 10  按 多注 规则显示
                                    list[index].more = list[index].randnum.split(',').length;
                                }
                                if(list[index].opencode && list[index].opencode.length > 0) {
                                    //注数 > 10  按 多注 规则显示
                                    list[index].opencode = list[index].opencode.join("");
                                } else {
                                    list[index].opencode = "";
                                }

                                // if(list[index].expect == "第1" && list[index].scope) {
                                //     list[index].except = list[index].scope.split('-')[0]
                                // }

                                this.detail_list.push(list[index])
                            }
                            //复制号码
                            this.copy_number = list[0].randnum;
                            try {
                                //复制计划
                                this.copy_plan = JSON.stringify(this.detail_list.filter(item => Boolean(item.plan_name)));
                            } catch (error) {
                                console.log('copy_plan:',error)
                            }                            
                        }
                    }else {
                        this.detail_list = [];
                        this.total = {};
                        response.data.msg && this.$message.error(response.data.msg);
                    }
                })
            },
            getWanfaList() {
                //获取玩法
                getWanfaList(this.lottery.loty).then((response)=>{
                    if (response.data.code == 200) {
                        
                    }
                })
            },      
            getPlanMashu2() {
                //获取玩法 码数
                getPlanMashu2(this.lottery.loty,this.wanfa_value,this.wanfa_code).then((response)=>{
                    if (response.data.code == 200) {
                        let list = response.data.data.list;
                        let type = response.data.data.type;
                        let options = [];
                        if(type == 0) {
                            for (const key in list) {  
                                options.push({
                                    value: key,
                                    label: list[key]
                                })
                            }
                            this.mashu_options = options;
                        } else if(type == 1) {
                            this.mashu_input_value = list[0] + '至'+ list[1];
                            this.form_mashu.start = Number(list[0]);
                            this.form_mashu.end = Number(list[1]);
                        } else if (type == 2) {
                           this.mashu_input_value = list[0];
                        }
                        //默认选择
                        this.mashu_value = response.data.data.mashu;
                        this.mashu_type =type;
                        this.getPlan(this.lottery.loty);
                    }
                })
            },            
            getPlanCollect() {
                //收藏列表
                getPlanCollect(this.lottery.loty).then((response)=>{
                    if (response.data.code == 200) {
                        this.collect_list = response.data.data.collect;
                        this.collect_list.forEach(element => {
                            element.quantity = get_random_num(100,9999)
                        });
                    }else {
                        this.collect_list = [];
                        this.$message.error(response.data.msg);
                    }
                })
            },
            clickCopy(type) {
                this.$copyText(type == 'plan' ? this.copy_plan : this.copy_number).then((e) => {
                    this.$message.success('复制成功')
                }, (e) => {
                    this.$message.error('复制失败')
                })
            }            
        },
        beforeDestroy() {
            //移除监听
            this.$eventBus.$off('lotteryPlanIssue');
        }
    }
</script>

<style lang="scss">
.page-main.page-plan {        
    .main-bd {
        .main-bd_left {
            width: 530px;
            height: 590px;
            .filter {
                width: 100%;
                min-height: 90px;
                box-sizing: border-box;
                margin-bottom: 12px;
                background: #FAEADA;
                border: 1px solid #DCA66A;
                display: flex;
                justify-content: space-between;
                padding: 12px 15px;
                .el-select {
                    height: 30px;
                    .el-input__inner {
                        height: 30px;
                        line-height: 30px;
                        padding-left: 10px;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
                .el-input {
                    height: 30px;
                    .el-input__inner {
                        height: 30px;
                        line-height: 30px;
                        padding-left: 10px;
                        padding-right: 20px;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
                .l {
                    width: 412px;
                    display: flex;
                    flex-flow: column;
                    justify-content: space-between;
                    .col {
                        display: flex;
                        justify-content: space-between;
                        .item {
                            display: flex;
                            align-items: center;
                            > span {
                                color: #A67B58;
                                margin-right: 8px;
                            }
                        }
                    }
                }
                .r {

                    .button-1 {
                        width: 75px;
                        height: 70px
                    };
                }
            }
            .bd {
                .line-list { 
                    .line-list_bd {
                        height: 405px;
                    }
                }
            }
        }
        .main-bd_right {
            height: 590px;
            .bd {
                height: 503px;
            }
        }
    }
}

.dialog_wanfa{
    min-width: 500px;
    width: 30%;
    .wanfa_code_list {        
        min-height: 300px;
        .el-radio-group {
            > div {
                margin-bottom: 20px;
            }
        }
    }
}

.dialog_mashu{
    min-width: 500px;
    width: 30%;
    .dialog_mashu-bd {        
        min-height: 60px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/plan/index.vue